import React from 'react';
import { Box, Text } from '@chakra-ui/react';

/**
 * NoDataState Component
 *
 * A reusable empty state component that displays a message when no data is available.
 * Use this to show empty states in lists, tables, or sections.
 *
 * @param {Object} props
 * @param {string} props.message - The message to display when no data is available
 *
 * @example
 * <NoDataState message="No records found" />
 */
const NoDataState = ({ message }) => (
  <Box p={6} borderRadius="xl" bg="backGround" borderWidth="1px" borderColor="whiteAlpha.300">
    <Text color="white" fontSize="md">{message}</Text>
  </Box>
);

export default NoDataState;
